export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0003s_0000_Black-&-White-38.70de69fb.png";